let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("brdUw")).then(() => parcelRequire('h32d2'));